import { Radio, RadioProps } from '@mui/material';
import React from 'react';

interface MoRadioProps extends RadioProps {}

export function MoRadio(props: MoRadioProps) {
  return <Radio {...props} color="primary" />;
}
